/* import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import React, { useState } from 'react'
import { makeStyles } from '@mui/styles';
import { Link } from 'react-scroll';
import { ColoresDPana, ColorsDPana } from '../../../utils/Color';
import logo from '../../../assets/imagenes/logo.png';
import "./style.css";
interface ItemCategoriaProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
  themeColor?: ColoresDPana;
  style?: React.CSSProperties;
  handleClick?: any;
  handleScrollSection?: any;
  Titulo?: any;
  ID: number;
  Imagen?: string;
  esActivo?: boolean;
  idx?: number;
}

const useStyles = makeStyles({
  rootActivo: {
    borderRadius: 20,
    width: 90,
    height: 111,
    background: `rgb(${ColorsDPana.primary[0]}, ${ColorsDPana.primary[1]}, ${ColorsDPana.primary[2]})`,
  },
  root: {
    borderRadius: 20,
    width: 85,
    height: 95,
    marginTop: -2,
    background: `rgb(${ColorsDPana.secundary[0]}, ${ColorsDPana.secundary[1]}, ${ColorsDPana.secundary[2]})`,
  },
  media: {
    padding: 0,
    height: 60,
    width: 60,
    minHeight: 60,
    minWidth: 60,
    maxHeight: 60,
    maxWidth: 60,
    display: "block",
    borderRadius: '50%',
    objectFit: 'cover',
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: "0px",
    boxShadow: "none",
    border: `2px dashed rgb(${ColorsDPana.primary[0]}, ${ColorsDPana.primary[1]}, ${ColorsDPana.primary[2]})`,
  },
  CardCenter: {
    background: `rgb(${ColorsDPana.secundary[0]}, ${ColorsDPana.secundary[1]}, ${ColorsDPana.secundary[2]})`,
    height: 122,
    borderRadius: 0,
    boxShadow: "none",
  },
  CardCenterActivo: {
    height: 117,
    borderRadius: 0,
    boxShadow: "none",
    background: `rgb(${ColorsDPana.primary[0]}, ${ColorsDPana.primary[1]}, ${ColorsDPana.primary[2]})`,
  },
  ActionArea: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center"
  },
  tituloActivo: {
    color: `rgb(${ColorsDPana.primary[0]}, ${ColorsDPana.primary[1]}, ${ColorsDPana.primary[2]})`,
    fontSize: "12px",
    fontWeight: 700,
    marginTop: "10px"
  },
  titulo: {
    color: `rgb(${ColorsDPana.white[0]}, ${ColorsDPana.white[1]}, ${ColorsDPana.white[2]})`,
    fontSize: "10px",
    fontWeight: 700,
    textAlign: "center",
    marginTop: "10px"
  },
  link: {
    textDecoration: "none"
  },
  imgCarousel: {
    borderRadius: "50%",
    objectFit: "cover",
    height: "50px",
    width: "50px"
  },
  contentItem: {
    backgroundColor: "rgba(0,0,0,0)"
  }
});
export default function ItemCategoria({ idx, ID, esActivo, handleScrollSection, handleClick, Titulo, Imagen, children, className, themeColor = ColorsDPana.sky_blue, style, ...restOfProps }: ItemCategoriaProps) {
  const [activo, setActivo] = useState(esActivo);
  const classes = useStyles();
  const onClick = () => {
    setActivo(true);
    handleClick(activo);
  }

  const onLinkActivo = () => {
    setActivo(true);
    handleScrollSection(idx);
  };
  const onLinkinActivo = () => {
    setActivo(false);
  };


  return (
    <Link
      activeClass={classes.link}
      to={`cat${ID}`}
      spy={true}
      smooth={true}
      offset={-200}
      duration={500}
      onSetActive={() => { onLinkActivo() }}
      onSetInactive={() => { onLinkinActivo() }}
    >
      <Card
        className={!activo ? classes.root : classes.rootActivo}>
        <Card className={!activo ? classes.CardCenter + " h-100" : classes.CardCenterActivo + " h-100"}>
          <CardActionArea onClick={() => { onClick(); }} onBlur={() => { setActivo(false) }} className={classes.ActionArea + " h-100 p-2"}>
            <CardMedia
              className={classes.media + " align-top"}
              image={Imagen ? Imagen : logo}
              title={Titulo}
            />
            <CardContent style={{ padding: 1 }}>
              <Typography className={!activo ? classes.titulo + "  lh-1 text-center position-relative w-100 h-100" : classes.tituloActivo + " lh-1 text-center position-relative w-100 h-100"} gutterBottom variant='button' component='article'  >
                {Titulo}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Card>
    </Link>
  )
}
 */
import React, { useState } from 'react'
import { Link } from 'react-scroll';
import { ColoresDPana, ColorsDPana } from '../../../utils/Color';
import { makeStyles } from '@mui/styles';
import logo from '../../../assets/imagenes/comida1.jpg';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import "./style.css";
import { addDefaultSrcOnError } from '../../../utils/helpers';

interface ItemCategoriaProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
  themeColor?: ColoresDPana;
  style?: React.CSSProperties;
  handleClick?: any;
  handleScrollSection?: any;
  Titulo?: any;
  ID: number;
  Imagen?: string;
  esActivo?: boolean;
  idx?: number;
}


const useStyles = makeStyles({
  rootActivo: {
    borderRadius: '0px !important',
    width: 95,
    height: '118px !important',
    backgroundColor: `rgb(${ColorsDPana.white[0]}, ${ColorsDPana.white[1]}, ${ColorsDPana.white[2]}) !important`,
  },
  root: {
    borderRadius: '0px !important',
    width: 95,
    height: '118px !important',
    backgroundColor: `rgb(${ColorsDPana.secundary[0]}, ${ColorsDPana.secundary[1]}, ${ColorsDPana.secundary[2]}) !important`,
  },
  media: {
    padding: 0,
    height: 60,
    width: 60,
    minHeight: 60,
    minWidth: 60,
    maxHeight: 60,
    maxWidth: 60,
    display: "block",
    borderRadius: '50%',
    objectFit: 'cover',
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: "0px",
    boxShadow: "none",
    border: `2px dashed rgb(${ColorsDPana.primary[0]}, ${ColorsDPana.primary[1]}, ${ColorsDPana.primary[2]})`,


  },
  CardCenter: {
    backgroundColor: `rgb(${ColorsDPana.primary[0]}, ${ColorsDPana.primary[1]}, ${ColorsDPana.primary[2]})!important`,
    height: 122,
    borderRadius: 0,
    boxShadow: "none",
  },
  CardCenterActivo: {
    height: 117,
    borderRadius: 0,
    boxShadow: "none",
    background: `linear-gradient(180deg, #7c0000,#51000099, #cfbcbc6e) !important`,
    border: "2px solid #ffffff85",
    borderTop: "none"
  },
  ActionArea: {
    display: "flex !important",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center"
  },
  tituloActivo: {
    color: `rgb(${ColorsDPana.secundary[0]}, ${ColorsDPana.secundary[1]}, ${ColorsDPana.secundary[2]})`,
    fontSize: "0.7rem !important",
    fontWeight: 700,
    marginTop: "10px"
  },
  titulo: {
    color: `rgb(${ColorsDPana.white[0]}, ${ColorsDPana.white[1]}, ${ColorsDPana.white[2]})`,
    fontSize: "0.6rem !important",
    fontWeight: 700,
    textAlign: "center",
    marginTop: "10px"
  },
  link: {
    textDecoration: "none"
  },
  imgCarousel: {
    borderRadius: "50%",
    objectFit: "cover",
    height: "50px",
    width: "50px",
    border: "1px solid #fff"
  },
  contentItem: {
    backgroundColor: "rgba(0,0,0,0)"
  }
});
export default function ItemCategoria({ idx, ID, esActivo, handleScrollSection, handleClick, Titulo, Imagen, children, className, themeColor = ColorsDPana.sky_blue, style, ...restOfProps }: ItemCategoriaProps) {
  const [activo, setActivo] = useState(esActivo);
  const classes = useStyles();
  const [offset, setOffset] = useState(-220);
  const onClick = () => {
    setActivo(true);
    handleClick();
  }

  const onLinkActivo = () => {
    setActivo(true);
    handleScrollSection(idx);
  };
  const onLinkinActivo = () => {
    setActivo(false);
  };


  return (
    <Link
      activeClass={classes.link}
      to={`cat${ID}`}
      spy={true}
      smooth={true}
      offset={-235}
      duration={500}
      onSetActive={() => { onLinkActivo() }}
      onSetInactive={() => { onLinkinActivo() }}
    >
      <Card
        className={!activo ? classes.root + " h-100" : classes.rootActivo + " h-100"}>
        <Card className={!activo ? classes.CardCenter + " h-100" : classes.CardCenterActivo + " h-100"}>
          <CardActionArea onClick={() => { onClick(); }} onBlur={() => { setActivo(false) }} className={classes.ActionArea + " h-100 p-2"}>
            <img className={classes.imgCarousel} onError={addDefaultSrcOnError} src={Imagen ? Imagen : logo} />
            <CardContent style={{ padding: 1 }}>
              <Typography className={!activo ? classes.titulo + "  lh-1 text-center position-relative w-100 h-100" : classes.tituloActivo + " lh-1 text-center position-relative w-100 h-100"} gutterBottom variant='button' component='article'>
                {Titulo}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Card>
    </Link>
  )
}
